import { Column, CreateDateColumn, Entity, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";
import { Field, ObjectType } from "type-graphql";
import User from "./user";

/** A session of a user (planning) */
@Entity({
    name: 'session'
})
@ObjectType()
export default class Session {
    /** The planning uuid */
    @PrimaryGeneratedColumn('uuid')
    @Field(() => String)
    public uuid: string

    /** The ip address of the session */
    @Column('varchar')
    public ip: string

    /** The related planning */
    @ManyToOne(() => User, { nullable: false, onDelete: 'CASCADE' })
    @Field(() => User)
    public user: User

    /** The created at timestamp */
    @CreateDateColumn({
        type: 'timestamp'
    })
    @Field(() => Date)
    public createdAt: Date

    /** The timestamp at which it was updated */
    @UpdateDateColumn({
        type: 'timestamp',
        name: 'updatedAt'
    })
    @Field(() => Date)
    public updatedAt: Date
}